var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialIcons9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75269 26.7773C20.7842 31.9386 27.4031 31.9386 38.4346 26.7773",
    stroke: "#00C5FF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8295 29.871L34.0358 34C34.0358 34 43.2382 31.2583 46.1704 26.7742C46.1704 24.7097 47.3398 9.95458 39.5515 5.09677C36.2421 3.03226 30.7263 2 30.7263 2L28.52 6.12903H24.1074",
    stroke: "#00C5FF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4372 29.871L14.2309 34C14.2309 34 5.02847 31.2583 2.0963 26.7742C2.0963 24.7097 0.926959 9.95458 8.7152 5.09677C12.0246 3.03226 17.5404 2 17.5404 2L19.7467 6.12903H24.1593",
    stroke: "#00C5FF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3644 22.6428C14.5376 22.6428 13.0549 20.7951 13.0549 18.5138C13.0549 16.2325 14.5376 14.3848 16.3644 14.3848C18.1912 14.3848 19.6738 16.2325 19.6738 18.5138C19.6738 20.7951 18.1912 22.6428 16.3644 22.6428ZM31.8085 22.6428C29.9817 22.6428 28.499 20.7951 28.499 18.5138C28.499 16.2325 29.9817 14.3848 31.8085 14.3848C33.6353 14.3848 35.1179 16.2325 35.1179 18.5138C35.1179 20.7951 33.6353 22.6428 31.8085 22.6428Z",
    stroke: "#00C5FF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcons9);
export default __webpack_public_path__ + "static/media/social-icons9.3d4ed528d159357f0a02b43869690b15.svg";
export { ForwardRef as ReactComponent };